<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.923" height="21.049" viewBox="0 0 20.923 21.049">
    <path class="b"
          d="M88.218,82.994V78.677H81.03v-2.2a4.109,4.109,0,1,0-2.049,0v2.2h-7.2v4.317a3.094,3.094,0,1,0,2.06-.044V80.731h5.139v2.241a3.084,3.084,0,1,0,2.06,0V80.731H86.18V82.95a3.077,3.077,0,1,0,4.043,2.914A3.14,3.14,0,0,0,88.218,82.994ZM77.946,72.514A2.054,2.054,0,1,1,80,74.568,2.055,2.055,0,0,1,77.946,72.514Zm-5.067,14.38a1.03,1.03,0,1,1,1.03-1.03A1.032,1.032,0,0,1,72.879,86.894Zm7.122,0a1.03,1.03,0,1,1,1.03-1.03A1.032,1.032,0,0,1,80,86.894Zm7.122,0a1.03,1.03,0,1,1,1.03-1.03A1.032,1.032,0,0,1,87.122,86.894Z"
          transform="translate(-69.55 -68.15)"/>
  </svg>
</template>

<script>
export default {
  name: 'MarketsIcon'
}
</script>

<style scoped>
svg .b {
  fill: #fff;
  stroke-width: 0;
}
</style>
